import React from 'react';
import { CTAButton } from './CTAButton';
import { AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
export function ProblemSolution() {
  return <section className="bg-gradient-to-b from-[#0d1b2a] to-[#060e1a] text-white py-16 md:py-24 px-4 relative" data-id="element-149">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-150">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-10 text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 uppercase leading-tight drop-shadow-sm" data-id="element-151">
          APRENDÉ UNA HABILIDAD PRÁCTICA, ÚTIL Y CON DEMANDA REAL
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-152">
          <p data-id="element-153">
            Si querés empezar en el mundo de la instalación de cámaras, pero
            sentís que no sabés por dónde arrancar, este sistema fue creado para
            vos.
          </p>

          <p data-id="element-154">
            Porque la mayoría de las personas que quiere aprender este oficio se
            encuentra con el mismo problema:
          </p>

          <div className="bg-[#0a111a] border border-red-900/50 p-6 md:p-8 rounded-xl my-8 shadow-[0_0_30px_rgba(220,38,38,0.1)] relative overflow-hidden" data-id="element-155">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-red-500 to-red-900" data-id="element-156"></div>
            <div className="flex items-start gap-4" data-id="element-157">
              <AlertTriangleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-158" />
              <p className="text-red-300 font-medium italic text-lg md:text-xl leading-relaxed" data-id="element-159">
                Ven videos sueltos. Encuentran información incompleta. No
                entienden qué equipo comprar. Se confunden con el cableado. No
                saben configurar el sistema. Y mucho menos cómo empezar a cobrar
                por este servicio.
              </p>
            </div>
          </div>

          <p data-id="element-160">
            Entonces pasan los días, siguen postergando y nunca terminan de
            arrancar.
          </p>
        </div>

        <div className="mt-20 mb-12" data-id="element-161">
          <h3 className="text-2xl md:text-4xl font-bold text-center mb-10 text-white uppercase tracking-wide" data-id="element-162">
            LA REALIDAD ES QUE NO NECESITÁS NACER SABIENDO
          </h3>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed bg-[#0d1b2a]/50 p-8 rounded-2xl border border-blue-900/30" data-id="element-163">
            <p data-id="element-164">
              Lo que necesitás es un proceso claro. Un sistema que te muestre,
              paso a paso, cómo empezar desde cero y avanzar con seguridad.
            </p>

            <p data-id="element-165">
              Porque una cosa es mirar contenido suelto... Y otra muy distinta
              es seguir una guía pensada para ayudarte a entender:
            </p>

            <ul className="space-y-4 my-8 pl-2 md:pl-6" data-id="element-166">
              {['cómo funciona la videovigilancia', 'qué equipos existen', 'cómo instalar correctamente', 'cómo configurar el sistema', 'cómo resolver fallas', 'y cómo convertir esta habilidad en una oportunidad real de ingresos'].map((item, i) => <li key={i} className="flex items-start bg-[#0a1628] p-3 rounded-lg border border-blue-900/20" data-id="element-167">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0" data-id="element-168" />
                  <span className="font-medium text-gray-200" data-id="element-169">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mt-12" data-id="element-170">
              <p className="font-bold text-xl md:text-2xl text-yellow-400 mb-3 uppercase tracking-wider" data-id="element-171">
                Eso es exactamente lo que vas a encontrar dentro de:
              </p>
              <p className="font-black text-3xl md:text-5xl text-white mb-8 drop-shadow-lg" data-id="element-172">
                SISTEMA COMPLETO DE <br className="hidden md:block" data-id="element-173" />
                <span className="text-blue-400" data-id="element-174">0 A INSTALADOR DE CÁMARAS</span>
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-175">
          <CTAButton className="w-full md:w-auto text-lg md:text-xl py-5 px-10" data-id="element-176">
            🔒 ASEGURÁ TU LUGAR AHORA - CUPOS LIMITADOS
          </CTAButton>
        </div>
      </div>
    </section>;
}